var config = {
  /*
   * websocket server
   * im-api-v2.easemob.com/ws 线上环境
   * im-api-v2-hsb.easemob.com/ws 沙箱环境
   */
  socketServer:
    (window.location.protocol === "https:" ? "https:" : "http:") +
    "//im-api-v2.easemob.com/ws",
    
  /*
   * Backend REST API URL
   * a1.easemob.com 线上环境
   * a1-hsb.easemob.com 沙箱环境
   */
  restServer:
    (window.location.protocol === "https:" ? "https:" : "http:") +
    "//a1.easemob.com",

  appkey: "1175260507193934#feisuzhushou",
  // appkey: '1143230620161731#fawuersi',
  // appkey: '1158221114129396#richcatcloud',
  Host: "easemob.com",
  https: true,

  /*
   * 公有云配置默认为 true，
   * 私有云配置请设置 isHttpDNS = false , 详细文档：http://docs-im.easemob.com/im/web/other/privatedeploy
   */
  isHttpDNS: true,
  isMultiLoginSessions: true,
  isSandBox: false, //内部测试环境，集成时设为false
  isDebug: true,
  autoReconnectNumMax: 10,
  isWebRTC:
    window.RTCPeerConnection && /^https\:$/.test(window.location.protocol),
  useOwnUploadFun: false,
  i18n: "cn",
  isAutoLogin: true,
  p2pMessageCacheSize: 500,
  delivery: false,
  groupMessageCacheSize: 200,
  loglevel: "ERROR",
  enableLocalStorage: true,

  deviceId: "webim",
};
export default config;
